"use client";

import Link from "next/link";
import { useEffect } from "react";
import { SiteFooter, SiteHeader, SkipLink } from "../components/site-chrome";
import styles from "../components/public-page.module.css";

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <>
      <SkipLink />
      <SiteHeader />
      <main id="main-content" className={styles.main}>
        <section className={styles.hero}>
          <p className={styles.eyebrow}>SOMETHING WENT WRONG</p>
          <h1>We couldn&apos;t load this page.</h1>
          <p className={styles.intro}>
            Your work is safe. Try again, or go back to the homepage.
            {error.digest ? ` If it keeps happening, quote reference ${error.digest}.` : ""}
          </p>
          <button type="button" className={styles.primary} onClick={reset}>Try again</button>{" "}
          <Link className={styles.primary} href="/">Go to the homepage</Link>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
